import { useMutation, UseMutationConfig } from '@libs/use';
import { CreateInitialPublicOffer } from '@libs/api-reference';

import * as API from '../requests';

function offerFactory(data: CreateInitialPublicOffer) {
  return {
    ...data,
    orderExecutionType: 'Desktop-Helium-IPO',
  };
}

type UseCreateInitialPublicOfferQueryType = {
  onSuccess?: UseMutationConfig<any>['onSuccess'];
  onReject?: UseMutationConfig<any>['onReject'];
};

export default function useCreateInitialPublicOfferQuery({
  onReject,
  onSuccess,
}: UseCreateInitialPublicOfferQueryType) {
  const { execute: createInitialPublicOffer, ...query } = useMutation(
    (data: CreateInitialPublicOffer) =>
      API.createInitialPublicOffer(offerFactory(data)),
    {
      onSuccess,
      onReject,
    }
  );

  return { createInitialPublicOffer, ...query };
}
